export function importComponent (name) {
    if (name === 'Slider') {
        return import('components/Slider/Slider.js')
    }

    if (name === 'Tabs') {
        return import('components/Tabs/Tabs.js')
    }

    if (name === 'Map') {
        return import('components/Map/Map.js')
    }

    if (name === 'ProductsGrid') {
        return import('components/ProductsGrid/ProductsGrid.js')
    }

    if (name === 'Timeline') {
        return import('components/Timeline/Timeline.js')
    }

    if (name === 'ContactsBoxes') {
        return import('components/ContactsBoxes/ContactsBoxes.js')
    }

    if (name === 'Header') {
        return import('components/Header/Header.js')
    }

    if (name === 'Overlay') {
        return import('components/Overlay/Overlay.js')
    }

    if (name === 'Faq') {
        return import('components/Faq/Faq.js')
    }
}

// only scss

import 'components/SquareBoxes/SquareBoxes.scss'
import 'components/InfoBoxes/InfoBoxes.scss'
import 'components/Footer/Footer.scss'
import 'components/PageTitle/PageTitle.scss'
import 'components/PostsList/PostsList.scss'
import 'components/Post/Post.scss'
import 'components/SearchResults/SearchResults.scss'
import 'components/FormThankYou/FormThankYou.scss'


// WEBPACK FOOTER //
// ./mtwp/Theme/Components/index.js